import { render, staticRenderFns } from "./ExchangeRateNotification.vue?vue&type=template&id=f8c28b24&"
import script from "./ExchangeRateNotification.vue?vue&type=script&lang=js&"
export * from "./ExchangeRateNotification.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeRateNotification.vue?vue&type=style&index=0&id=f8c28b24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports